import React from "react";
import SimpleCarousel from "../SimpleCarousel";
import BookServiceButton from "./BookServiceButton";
import {
  publicSpeakingMedia,
  publicSpeakingTopics,
  articlesAndPodcasts,
} from "../../data/servicesContent";

const PublicSpeakingSection = () => {
  return (
    <div className="space-y-14">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-display text-3xl font-semibold text-[#21167D] mb-3">
          Prises de parole / Éducation populaire
        </h2>
        <p className="font-accent italic text-xl text-[#4A4458] mb-3">
          Interventions publiques, ateliers d'éducation populaire, prises de parole médias.
        </p>
        {/* Texte issu de la plaquette (présentation p. 2, approche p. 5) */}
        <p className="text-[#4A4458] leading-relaxed">
          Psychosociologue de formation et formatrice depuis plus de 10 ans, je prends
          la parole sur les questions d'identités intersectionnelles — culture, genre,
          sexualité, neuroatypie et spiritualité —, leur impact sur la santé mentale,
          et les dynamiques de vivre-ensemble interculturel.
        </p>
        <BookServiceButton serviceId="prise-de-parole" className="mt-6" />
      </div>

      {/* Thèmes d'intervention (plaquette p. 5 et p. 7) */}
      <div>
        <h3 className="font-display text-2xl font-semibold text-[#21167D] mb-6 text-center">
          Thèmes d'intervention
        </h3>
        <ul className="grid sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {publicSpeakingTopics.map((topic) => (
            <li
              key={topic.title}
              className="p-5 bg-[#FDFBF5] rounded-2xl border border-[#DCB071]/30 shadow-sm"
            >
              <p className="font-accent font-semibold text-lg text-[#21167D] mb-1">{topic.title}</p>
              <p className="text-sm text-[#4A4458] leading-relaxed">{topic.text}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Carrousel photos / vidéos — médias temporaires en attendant les vrais */}
      <div className="max-w-3xl mx-auto">
        <SimpleCarousel items={publicSpeakingMedia} />
        <p className="text-center text-xs text-[#4A4458]/70 italic mt-3">
          [À COMPLÉTER : remplacer par les vrais médias (photos / vidéos)]
        </p>
      </div>

      {/* Articles et podcasts */}
      <div>
        <h3 className="font-display text-2xl font-semibold text-[#21167D] mb-6 text-center">
          Articles &amp; podcasts
        </h3>
        {articlesAndPodcasts.length > 0 ? (
          <ul className="max-w-2xl mx-auto space-y-3">
            {articlesAndPodcasts.map((item) => (
              <li key={item.id}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block p-4 bg-[#FDFBF5] rounded-xl shadow-sm hover:shadow-md transition-shadow text-[#21167D] font-medium"
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-center text-[#4A4458]/70 text-sm italic">
            [À COMPLÉTER : liste d'articles et liens vers les podcasts]
          </p>
        )}
      </div>
    </div>
  );
};

export default PublicSpeakingSection;
